module.exports = __webpack_public_path__ + "img/artnhealing_main_05.15aaca6c.jpg";